import React from 'react';
import styles from './Section.module.css';

const FeeComponent = () => {
  return (
    <div className={styles.contentSection}>
      <div className={styles.sectionTitle}>Why do you need a Withdraw fee?</div>
      <div className={styles.sectionContent}>
        <p>When we make a transaction, the information is broadcast to the network, and the miners collect and package the production blocks, and only after the block is produced, the transaction is recognized. Although the miners will get a fixed monetary reward after digging into the block, according to the rules, the reward will gradually be halved and become less and less, and eventually the miners may not be profitable. Therefore, transaction fees are needed to maintain the enthusiasm of miners for mining.</p>
      </div>

      <div className={styles.subSectionTitle}>The role of the Withdraw fee</div>
      <div className={styles.sectionContent}>
        <ol>
          <li>Encourage miners to mine</li>
          <li>Prevent excessive small transactions from hitting the network. Due to the P2P network, the ability of transaction processing is limited. If everyone frequently conducts small transactions, the network will be congested, causing delays or even stagnation. So set a threshold, the amount of natural transactions will be reduced when there is a small transaction.</li>
        </ol>
      </div>

      <div className={styles.subSectionTitle}>How much is the Withdraw fee?</div>
      <div className={styles.sectionContent}>
        <p>Since the transaction is a two-way charge, it means that the sale of a digital currency requires at least a 0.1% Withdraw fee to the platform.</p>
      </div>
    </div>
  );
};

export default FeeComponent;
